<template>
  <VApp class="landing">
    <div class="landing-qr">
      <LandingHeader class="px-4 px-md-8" />
      <VCarousel
        ref="slider"
        v-model="slide"
        class="landing-qr__carusel"
        :continuous="false"
        cycle
        :show-arrows="false"
        hide-delimiters
        :height="sliderHeight"
      >
        <VCarouselItem class="" reverse-transition="fade-transition"
                       transition="fade-transition"
        >
          <div class="landing-qr__carusel-item landing-qr__carusel-item_1">
            <div class="landing-qr__carusel-item-bg" :style="`background-image: url(${require('@/assets/img/landing/qr-top/qr-slide-bg1.png')}`" />
            <VContainer style="height: 100%;">
              <div class="landing-qr__carusel-content">
                <div class="landing-qr__carusel-text-wrap">
                  <div class="landing-qr__title">
                    <i18n path="qrTitle" for="truck">
                      <a @click="goToSlide(1)">{{ $t('truck') }}</a>
                    </i18n>
                  </div>
                  <div class="landing-qr__text">
                    {{ $t('qrText') }}
                  </div>
                  <button class="landing-btn landing-qr__btn" @click="toRegister">
                    {{ $t('btnQr') }}
                  </button>
                  <SlidePagination class="landing-qr__pagination d-none d-md-block" :value="slide" @input="goToSlide($event)" />
                </div>
                <div class="landing-qr__carusel-image-wrap">
                  <img :src="slides[0].src" alt="" class="landing-qr__carusel-image d-none d-sm-block">
                  <img :src="slides[0].mobSrc" alt="" class="landing-qr__carusel-image d-sm-none">
                </div>
              </div>
            </VContainer>
          </div>
        </VCarouselItem>
        <VCarouselItem class="" reverse-transition="fade-transition"
                       transition="fade-transition"
        >
          <div class="landing-qr__carusel-item landing-qr__carusel-item_2">
            <div class="landing-qr__carusel-item-bg" :style="`background-image: url(${require('@/assets/img/landing/qr-top/qr-slide-bg2.png')}`" />
            <VContainer style="height: 100%;">
              <div class="landing-qr__carusel-content">
                <div class="landing-qr__carusel-text-wrap">
                  <div class="landing-qr__title">
                    <i18n path="qrTitle" for="payDesk">
                      <a @click="goToSlide(2)">{{ $t('payDesk') }}</a>
                    </i18n>
                  </div>
                  <div class="landing-qr__text">
                    {{ $t('qrText') }}
                  </div>
                  <button class="landing-btn landing-qr__btn" @click="toRegister">
                    {{ $t('btnQr') }}
                  </button>

                  <SlidePagination class="landing-qr__pagination d-none d-md-block" :value="slide" @input="goToSlide($event)" />
                </div>
                <div class="landing-qr__carusel-image-wrap">
                  <img :src="slides[1].src" alt="" class="landing-qr__carusel-image d-none d-md-block">
                  <img :src="slides[1].mobSrc" alt="" class="landing-qr__carusel-image d-md-none">
                </div>
              </div>
            </VContainer>
          </div>
        </VCarouselItem>
        <VCarouselItem class="" reverse-transition="fade-transition"
                       transition="fade-transition"
        >
          <div class="landing-qr__carusel-item landing-qr__carusel-item_3">
            <div class="landing-qr__carusel-item-bg" :style="`background-image: url(${require('@/assets/img/landing/qr-top/qr-slide-bg3.png')}`" />
            <VContainer style="height: 100%;">
              <div class="landing-qr__carusel-content">
                <div class="landing-qr__carusel-text-wrap">
                  <div class="landing-qr__title">
                    <i18n path="qrTitle" for="payDesk">
                      <a @click="goToSlide(0)">{{ $t('aBoard') }}</a>
                    </i18n>
                  </div>
                  <div class="landing-qr__text">
                    {{ $t('qrText') }}
                  </div>
                  <button class="landing-btn landing-qr__btn" @click="toRegister">
                    {{ $t('btnQr') }}
                  </button>
                  <SlidePagination class="landing-qr__pagination d-none d-md-block" :value="slide" @input="goToSlide($event)" />
                </div>
                <div class="landing-qr__carusel-image-wrap">
                  <img :src="slides[2].src" alt="" class="landing-qr__carusel-image">
                </div>
              </div>
            </VContainer>
          </div>
        </VCarouselItem>
      </VCarousel>
    </div>
    <div class="how-it-works">
      <VContainer>
        <h2 class="landing-title">
          {{ $t('titleHowItWorks') }}
        </h2>
        <div class="how-it-works__wrap">
          <div class="how-it-works__item">
            <div class="how-it-works__step">
              1
            </div>
            <div class="how-it-works__icon-wrap">
              <img src="../assets/img/landing/how-it-works/how-it-works1.svg" alt="" class="how-it-works__icon">
            </div>
            <div class="how-it-works__text">
              {{ $t('howItWorksText1') }}
            </div>
          </div>
          <div class="how-it-works__item">
            <div class="how-it-works__step">
              2
            </div>
            <div class="how-it-works__icon-wrap">
              <img src="../assets/img/landing/how-it-works/how-it-works2.svg" alt="" class="how-it-works__icon">
            </div>
            <div class="how-it-works__text">
              {{ $t('howItWorksText2') }}
            </div>
          </div>
          <div class="how-it-works__item">
            <div class="how-it-works__step">
              3
            </div>
            <div class="how-it-works__icon-wrap">
              <img src="../assets/img/landing/how-it-works/how-it-works3.svg" alt="" class="how-it-works__icon">
            </div>
            <div class="how-it-works__text">
              <i18n path="howItWorksText3" for="demo">
                <VDialog v-model="dialog" width="500">
                  <template #activator="{on,attrs}">
                    <a v-bind="attrs" v-on="on">{{ $t('demo') }}</a>
                  </template>
                  <VCard>
                    <AppDialogHeader :title="$t('dialogHeader')" @close="dialog = false" />
                    <VCardText style="text-align: center">
                      <img style="width: 300px" :src="demo">
                    </VCardText>
                  </VCard>
                </VDialog>
              </i18n>
            </div>
          </div>
          <div class="how-it-works__item">
            <div class="how-it-works__step">
              4
            </div>
            <div class="how-it-works__icon-wrap">
              <img src="../assets/img/landing/how-it-works/how-it-works4.svg" alt="" class="how-it-works__icon">
            </div>
            <div class="how-it-works__text">
              {{ $t('howItWorksText4') }}
            </div>
          </div>
        </div>
        <button class="landing-btn how-it-works__btn" @click="toRegister">
          {{ $t('btnExamples') }}
        </button>
      </VContainer>
    </div>
    <LandingQrInfo />
    <div class="examples">
      <VContainer>
        <h2 class="landing-title">
          {{ $t('titleExamples') }}
        </h2>
        <VRow class="examples__wrap">
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-1.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-1.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-1.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-1.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-2.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-2.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-2.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-2.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-3.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-3.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-3.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-3.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-4.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-4.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-4.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-4.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-5.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-5.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-5.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-5.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-6.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-6.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-6.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-6.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-7.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-7.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-7.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-7.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-8.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-8.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-8.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-8.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
          <VCol cols="12" sm="6" md="4" class="examples__item">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-9.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'en'" :src="require('../assets/img/landing/qr-examples/en/examples-en-9.jpg')" alt="" class="examples__image d-sm-none">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-9.jpg')" alt="" class="examples__image d-none d-sm-block">
            <img v-if="$i18n.locale === 'ru'" :src="require('../assets/img/landing/qr-examples/ru/examples-ru-9.jpg')" alt="" class="examples__image d-sm-none">
          </VCol>
        </VRow>
        <button class="landing-btn examples__btn">
          {{ $t('btnExamples') }}
        </button>
      </VContainer>
    </div>
    <div class="landing-reviews">
      <VContainer>
        <h2 class="landing-title">
          {{ $t('titleReviews') }}
        </h2>
        <ReviewsQr class="landing-reviews__wrap" />
        <div class="text-center d-none">
          <div class="landing__icon">
            <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M34.5159 3.57227H5.48406C2.46008 3.57227 0 6.03242 0 9.05641V34.3231C0 34.7048 0.309375 35.0144 0.69125 35.0144C1.07313 35.0144 1.3825 34.7049 1.3825 34.3231V9.05641C1.3825 6.79477 3.2225 4.95477 5.48406 4.95477H30.8811C29.7479 5.96023 29.0319 7.42586 29.0319 9.05633V38.8036H1.3825V34.3231C1.3825 33.9414 1.07313 35.0144 0.69125 35.0144C0.309375 35.0144 0 34.0005 0 34.3823V39.4948C0 39.8766 0.309375 40.1861 0.69125 40.1861H29.723C30.1049 40.1861 30.4143 39.8766 30.4143 39.4948V9.05641C30.4143 6.79477 32.2543 4.95484 34.5159 4.95484C36.7775 4.95477 38.6175 6.79477 38.6175 9.05641V22.1227H30.4143C30.0324 22.1227 29.8824 22.4322 29.8824 22.8139C29.8824 23.1956 30.0324 23.5052 30.4143 23.5052H39.3088C39.6906 23.5052 40 23.1957 40 22.8139V9.05641C40 6.03242 37.5398 3.57227 34.5159 3.57227Z" fill="white" /><path d="M12.3233 21.4347C12.3222 21.8165 11.2482 22.1226 11.63 22.1238L16.9109 22.1399C17.2926 22.1411 17.6031 21.8325 17.6042 21.4508L17.6385 10.2257C17.6397 9.8438 17.3312 9.53348 16.9494 9.53231L3.70007 9.49186C3.31835 9.49069 3.00788 9.79912 3.00671 10.181L2.97244 21.4061C2.97127 21.788 3.27978 22.0983 3.66157 22.0995L11.63 22.1238C12.0117 22.125 12.3222 21.8165 12.3233 21.4347C12.3245 21.0528 12.016 20.7425 11.6342 20.7413L4.35696 20.7191L4.38702 10.8765L16.2538 10.9127L16.2238 20.7553L11.6342 20.7413C11.2525 20.7401 12.3245 21.0528 12.3233 21.4347Z" fill="white" /><path d="M35.9361 15.498H32.6287C32.2469 15.498 31.9375 15.8075 31.9375 16.1893C31.9375 16.5711 32.2469 16.8805 32.6287 16.8805H35.9361C36.318 16.8805 36.6273 16.571 36.6273 16.1893C36.6273 15.8076 36.3179 15.498 35.9361 15.498Z" fill="white" /><path d="M35.9361 12.1858H32.6287C32.2469 12.1858 31.9375 12.4952 31.9375 12.877C31.9375 13.2588 32.2469 13.5683 32.6287 13.5683H35.9361C36.318 13.5683 36.6273 13.2588 36.6273 12.877C36.6273 12.4952 36.3179 12.1858 35.9361 12.1858Z" fill="white" /><path d="M26.7306 25.2422H9.90609C9.52422 25.2422 9.21484 25.5516 9.21484 25.9334C9.21484 26.3152 9.52422 26.6247 9.90609 26.6247H26.7306C27.1125 26.6247 27.4219 26.3152 27.4219 25.9334C27.4219 25.5516 27.1125 25.2422 26.7306 25.2422Z" fill="white" /><path d="M26.2352 32.6792H21.6248C21.243 32.6792 20.9336 32.9887 20.9336 33.3704C20.9336 33.7522 21.243 34.0617 21.6248 34.0617H26.2352C26.6171 34.0617 26.9265 33.7522 26.9265 33.3704C26.9265 32.9887 26.6171 32.6792 26.2352 32.6792Z" fill="white" /><path d="M26.4653 28.8669H18.1248C17.743 28.8669 17.4336 29.1764 17.4336 29.5582C17.4336 29.94 17.743 30.2494 18.1248 30.2494H26.4653C26.8472 30.2494 27.1566 29.9399 27.1566 29.5582C27.1566 29.1765 26.8471 28.8669 26.4653 28.8669Z" fill="white" /></g><defs><clipPath id="clip0"><rect width="40" height="40" fill="white" transform="translate(0 0.5)" /></clipPath></defs></svg>
          </div>
          <div class="display-2">
            {{ $t('press') }}
          </div>
        </div>
        <LogotypesSlider class="landing__logotypes d-none" :items="inPress" :nogs="true" />
      </VContainer>
    </div>
    <div class="landing__content px-2 px-sm-4 px-md-8" style="padding: 4.25rem 0.5rem;">
      <h2 class="h2 text-center mb-4 mb-sm-6">
        {{ $t('registration') }}
        <LandingForm />
      </h2>
    </div>
    <TheFooter />
  </VApp>
</template>

<script>
import SlidePagination from '@/components/Landing/SlidePagination.vue';
import AppDialogHeader from '@/components/AppDialogHeader.vue';
import { HOME_DOMAIN } from '@/helpers/constants';
import TheFooter from '../components/TheFooter.vue';
import LandingHeader from '../components/Landing/LandingHeader.vue';
import LogotypesSlider from '../components/Landing/LogotypesSlider.vue';
import ReviewsQr from '../components/Landing/ReviewsQr.vue';
import LandingForm from '../components/Landing/LandingForm.vue';
import LandingQrInfo from '../components/Landing/LandingQrInfo.vue';
import Reviews from '../components/Landing/Reviews.vue';

export default {
  name: 'QrLanding',
  components: {
    Reviews,
    AppDialogHeader,
    SlidePagination,
    TheFooter,
    LandingQrInfo,
    LandingHeader,
    LogotypesSlider,
    ReviewsQr,
    LandingForm,
  },
  data() {
    return {
      slide: 0,
      dialog: false,
      HOME_DOMAIN,
    };
  },
  computed: {
    sliderHeight() {
      if (this.$vuetify.breakpoint.mdOnly) {
        return 540;
      }
      if (this.$vuetify.breakpoint.smOnly) {
        return 750;
      }
      if (this.$vuetify.breakpoint.xsOnly) {
        return 440;
      }
      return 640;
    },
    slides() {
      return [
        {
          // eslint-disable-next-line global-require,import/no-dynamic-require
          src: require(`@/assets/img/landing/qr-top/${this.$i18n.locale}/qr-slide-1.png`),
          // eslint-disable-next-line global-require,import/no-dynamic-require
          mobSrc: require(`@/assets/img/landing/qr-top/${this.$i18n.locale}/qr-slide-mob-1.png`),
        },
        {
          // eslint-disable-next-line global-require,import/no-dynamic-require
          src: require(`@/assets/img/landing/qr-top/${this.$i18n.locale}/qr-slide-2.png`),
          // eslint-disable-next-line global-require,import/no-dynamic-require
          mobSrc: require(`@/assets/img/landing/qr-top/${this.$i18n.locale}/qr-slide-mob-2.png`),
        },
        {
          // eslint-disable-next-line global-require,import/no-dynamic-require
          src: require(`@/assets/img/landing/qr-top/${this.$i18n.locale}/qr-slide-3.png`),
        },
      ];
    },
    demo() {
      // eslint-disable-next-line global-require,import/no-dynamic-require
      return require(`@/assets/img/landing/qr-top/${this.$i18n.locale}/demo.svg`);
    },
  },

  methods: {
    toRegister() {
      this.$vuetify.goTo('#register-form');
    },
    goToSlide(slide) {
      this.slide = slide;
    },
  },
  metaInfo() {
    return {
      title: this.$t('slogan'),
      meta: [
        { property: 'og:title', content: 'Huntica' },
        { property: 'og:url', content: `https://${this.HOME_DOMAIN}/` },
        { property: 'og:description', content: this.$t('sloganShort') },
        { property: 'og:image', content: 'https://via.placeholder.com/600x315' },
        { name: 'twitter:card', content: 'summary' },
      ],
    };
  },
};
</script>

<style lang="scss">
.landing {
  .v-content {
    padding-bottom: 306px !important;
  }
  &.v-application .primary--text {
    color: #3DB7EB !important;
  }
  .dots {
    display: flex;
    justify-content: center;
  }
  .v-carousel__controls  {
    &__item .v-icon {
      width: 10px !important;
      height: 10px !important;
      font-size: 10px !important;
    }

    .v-btn--icon {
      width: auto;
      height: auto;
    }

    .v-item--active {
      color: $success !important;

      .v-icon {
        opacity: 1;
      }
    }
  }
  .dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0 $spacer;
    transition: 0.3s;
    background: #c4c4c4;
    cursor: pointer;
    &.active {
      background: #71E6F5;
      cursor: default;
    }
  }
  @media #{map-get($display-breakpoints, 'md-and-up')} {
    .v-content {
      padding-bottom: 145px !important;
    }
  }
  @media #{map-get($display-breakpoints, 'lg-and-up')} {
    .container:not(.container--fluid) {
      max-width: 1315px;
    }
    .v-content {
      padding-bottom: 154px !important;
    }
  }
}
</style>

<style scoped lang="scss">
.landing-title {
  font-size: 2rem;
  line-height: 1.18;
  font-weight: 400;
  text-align: center;
  margin-bottom: 2.5rem;
  color: #000000;
}
.landing-btn {
  display: block;
  padding: 0.875rem 1.625rem;
  background: #1FC57F;
  color: #FFFFFF;
  box-shadow: 0 2px 0.25rem rgba(0, 0, 0, 0.24);
  border-radius: 0.25rem;
}
.landing-qr {
  position: relative;
  &:after {
    content: '';
    width: 14.5rem;
    height: 12.5rem;
    background: url("../assets/img/landing/qr-top/qr-bg-image1.svg") no-repeat center;
    background-size: contain;
    position: absolute;
    z-index: 2;
    left: -3.625rem;
    bottom: -1rem;
  }
  &__title {
    max-width: 23.25rem;
    font-size: 2.125rem;
    line-height: 1.32;
    font-weight: 300;
    color: #FFFFFF;
    margin-bottom: 1.25rem;
    a {
      cursor: pointer;
      color: #fff;
      border-bottom: 1px dashed #FFFFFF;
    }
  }
  &__text {
    max-width: 23.25rem;
    font-size: 1.125rem;
    line-height: 1.44;
    font-weight: 300;
    color: #FFFFFF;
    margin-bottom: 1.875rem;
  }
  &__carusel-item {
    padding: 0 2rem;
    height: 100%;
    background: linear-gradient(85.04deg, #0161A7 4.42%, #00B9F3 110.13%);
    position: relative;
    &_1 {
      .landing-qr__carusel-item-bg {
        background-position: 67% -25.5rem;
        background-size: 151.375rem;
      }
    }
    &_2 {
      .landing-qr__carusel-item-bg {
        background-position: center -14.5rem;
      }
      .landing-qr__carusel-image {
        position: absolute;
        bottom: -0.75rem;
      }
    }
    &_3 {
      .landing-qr__carusel-item-bg {
        background-position: center -16rem;
        background-size: 89.875rem;
        left: 17.5rem;
      }
      .landing-qr__carusel-image-wrap {
        position: absolute;
        top: 14.375rem;
        right: 22rem;
      }
    }
  }
  &__carusel-item-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    mix-blend-mode: multiply;
  }
  &__carusel-content {
    display: flex;
    justify-content: space-between;
    padding-top: 8.875rem;
    height: 100%;
    position: relative;
    z-index: 3;
  }
  &__carusel-text-wrap {
    min-width: 22.25rem;
    max-width: 22.25rem;
    margin-right: 1.5rem;
  }
  &__carusel-image-wrap {
    display: flex;
    align-items: flex-end;
    flex-grow: 1;
    padding-top: 2.125rem;
    position: relative;
  }
  &__carusel-image {
    max-width: 100%;
    max-height: 100%;
  }
  &__pagination {
    position: absolute;
    bottom: 2.5rem;
    left: 0;
  }
}
.how-it-works {
  background: #E9F3FE;
  padding: 4.25rem 0 3.625rem;
  &__wrap {
    display: flex;
  }
  &__item {
    padding-top: 2.25rem;
    position: relative;
    margin-right: 5.9375rem;
    margin-bottom: 4rem;
    &:last-child {
      margin-right: 0;
    }
  }
  &__step {
    width: 3.125rem;
    height: 3.125rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #FFFFFF;
    font-weight: 300;
    font-size: 1.125rem;
    color: #666666;
    position: absolute;
    top: 0;
    left: -2.1875rem;
  }
  &__icon-wrap {
    width: 9.4375rem;
    height: 9.4375rem;
    border-radius: 50%;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
  }
  &__text {
    max-width: 15rem;
    font-size: 1.125rem;
    font-weight: 300;
    line-height: 1.44;
    color: #333333;
  }
  &__btn {
    margin: 0 auto;
  }
}
.examples {
  background: #FFFFFF;
  padding: 4.25rem 0 4.375rem;
  &__wrap {
    margin: 0 -0.625rem;
  }
  &__item {
    padding: 0 0.625rem 1.25rem;
  }
  &__image {
    max-width: 100%;
    box-shadow: 0 2px 1.25rem rgba(0, 0, 0, 0.08);
    border-radius: 0.625rem;
  }
  &__btn {
    margin: 3.125rem auto 0;
  }
}
.landing-reviews {
  background: #fff;
  padding: 4.25rem 0.5rem;
  &__wrap {
    padding-top: 1.625rem;
  }
}
@media (max-width: 1376px) {
  .landing-qr__carusel-item {
    &_2 {
      .landing-qr__carusel-item-bg {
        background-position: center -15rem;
      }
    }
    &_3 {
      .landing-qr__carusel-image-wrap {
        right: 30%;
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'lg-and-down')} {
  .how-it-works {
    padding: 4.25rem 2.5rem 3.625rem;
    &__item {
      margin-right: 4.75rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .landing-qr {
    &:after {
      left: -6rem;
      bottom: -5rem;
    }
    &__title {
      font-size: 1.625rem;
      margin-bottom: 1.25rem;
    }
    &__text {
      font-size: 1rem;
      margin-bottom: 1.875rem;
    }
    &__carusel-item {
      &_1 {
        .landing-qr__carusel-item-bg {
          background-position: 59% -20rem;
          background-size: 118rem;
        }
      }
      &_3 {
        .landing-qr__carusel-item-bg {
          background-position: center -12rem;
          background-size: 68rem;
          left: 20.5rem;
        }
        .landing-qr__carusel-image-wrap {
          width: 10rem;
          top: 10.25rem;
          right: 16%;
        }
      }
    }
    &__carusel-text-wrap {
      min-width: 19rem;
      max-width: 19rem;
      margin-right: 1.25rem;
    }
    &__btn {
      padding: 0.625rem 1.375rem;
    }
  }
  .how-it-works {
    padding: 3.25rem 2rem;
    &__item {
      margin-right: 4.75rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .landing-qr {
    &:after {
      left: -5.25rem;
      bottom: -4rem;
    }
    &__title {
      max-width: 38.25rem;
      font-size: 2.125rem;
      margin: 0 auto 0.3125rem;
    }
    &__text {
      max-width: 35rem;
      font-size: 1.125rem;
      margin: 0 auto 1.25rem;
    }
    &__carusel-item {
      padding: 0 1.75rem;
      &_1 {
        .landing-qr__carusel-item-bg {
          background-position: 79% -8rem;
          background-size: 89rem;
        }
      }
      &_2 {
        .landing-qr__carusel-item-bg {
          background-position: center 0;
        }
        .landing-qr__carusel-content {
          padding-top: 7.75rem;
        }
        .landing-qr__carusel-image-wrap {
          margin-bottom: 1.25rem;
        }
        .landing-qr__carusel-image {
          position: static;
          max-width: 18rem;
        }
      }
      &_3 {
        .landing-qr__carusel-item-bg {
          background-position: center -2rem;
          background-size: 43rem;
          left: 0;
        }
        .landing-qr__carusel-content {
          padding-top: 26.5rem;
        }
        .landing-qr__carusel-image-wrap {
          width: 6rem;
          top: 13rem;
          right: 53%;
        }
      }
    }
    &__carusel-item-bg {
      background-position: 63%;
      background-size: cover;
    }
    &__carusel-content {
      flex-direction: column-reverse;
      height: auto;
      padding-top: 12.5rem;
      text-align: center;
    }
    &__carusel-text-wrap {
      min-width: inherit;
      max-width: inherit;
      margin-right: 0;
    }
    &__btn {
      padding: 0.875rem 1.625rem;
      margin: 0 auto;
    }
    &__carusel-image-wrap {
      max-width: 37.375rem;
      justify-content: center;
      padding-top: 0;
      margin: 0 auto 0.5rem;
    }
  }
  .how-it-works {
    padding: 2.375rem 2rem;
    &__wrap {
      flex-wrap: wrap;
    }
    &__item {
      width: 43%;
      margin-right: 7%;
      margin-bottom: 2.5rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .examples {
    padding: 3.125rem 0.5rem 3.125rem;
    &__title {
      margin-bottom: 1.875rem;
    }
    &__wrap {
      margin: 0 -0.5rem;
    }
    &__item {
      padding: 0 0.5rem 1rem;
      text-align: right;
      &:nth-child(even) {
        text-align: left;
      }
    }
    &__image {
      box-shadow: 0 1.53096px 15.3096px rgba(0, 0, 0, 0.08);
      border-radius: 0.4375rem;
    }
    &__btn {
      margin: 1.5rem auto 0;
    }
  }
  .landing-reviews {
    padding: 2.375rem 0.25rem 1.75rem;
    &__wrap {
      padding-top: 1.625rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'xs-only')} {
  .landing-qr {
    &:after {
      width: 6.5rem;
      height: 5.625rem;
      left: -2.75rem;
      bottom: inherit;
      top: 10rem;
    }
    &__title {
      max-width: 15rem;
      font-size: 1.125rem;
      margin: 0 auto 0.5rem;
    }
    &__text {
      max-width: 18rem;
      font-size: 0.875rem;
      line-height: 1.24;
      margin: 0 auto 0.9375rem;
    }
    &__carusel-item {
      background: linear-gradient(66.26deg, #0161A7 21.12%, #00B9F3 300.96%);
      padding: 0;
      &_1 {
        .landing-qr__carusel-item-bg {
          background-position: 82% -4rem;
          background-size: 39.5rem;
        }
      }
      &_2 {
        .landing-qr__carusel-item-bg {
          background-size: 46rem;
        }
        .landing-qr__carusel-content {
          padding-top: 3.75rem;
        }
        .landing-qr__carusel-image-wrap {
          margin-bottom: 0.5rem;
        }
        .landing-qr__carusel-image {
          width: 10.5rem;
        }
      }
      &_3 {
        .landing-qr__carusel-item-bg {
          background-position: center -1rem;
          background-size: 23rem;
          left: 0;
        }
        .landing-qr__carusel-content {
          padding-top: 13rem;
        }
        .landing-qr__carusel-image-wrap {
          width: 3.25rem;
          top: 6rem;
          right: 53%;
        }
      }
    }
    &__carusel-item-bg {
      background-size: 100%;
      background-position: 50% top;
    }
    &__carusel-content {
      padding-top: 5.5rem;
    }
    &__btn {
      padding: 0.875rem 1.625rem;
    }
    &__carusel-image-wrap {
      margin-bottom: 1.25rem;
    }
  }
  .landing-title {
    font-size: 1.125rem;
    margin-bottom: 0.625rem;
  }
  .landing-btn {
    padding: 0.375rem 1.125rem;
  }
  .how-it-works {
    padding: 1.125rem 0;
    &__wrap {
      flex-wrap: wrap;
    }
    &__item {
      display: flex;
      width: 100%;
      padding: 1.125rem 0 0 1.5625rem;
      margin-right: 0;
      margin-bottom: 1.25rem;
    }
    &__step {
      width: 2.125rem;
      height: 2.125rem;
      font-size: 0.875rem;
      left: 0;
    }
    &__icon-wrap {
      width: 5rem;
      min-width: 5rem;
      height: 5rem;
      margin-right: 0.625rem;
      margin-bottom: 0;
      padding: 0.875rem;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    &__text {
      font-size: 0.875rem;
    }
  }
  .examples {
    padding: 1.875rem 0 1.5rem;
    &__item {
      padding: 0 0.5rem;
      &:nth-child(even) {
        text-align: center;
      }
    }
    &__image  {
      display: block;
      border-radius: 0;
      margin: 0 auto;
    }
    &__btn {
      margin: 1.25rem auto 0;
    }
  }
}
@media only screen and (max-width: 374px) {
  .landing-qr__carusel-item_2 {
    .landing-qr__carusel-content {
      padding-top: 4.9375rem;
    }
    .landing-qr__carusel-image {
      width: 8.625rem;
    }
  }
}
@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .landing {
    &:before {
      min-height: 1250px;
    }
    &__top {
      margin-bottom: 21px;
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-up')} {
  .landing {
    &:after {
      top: initial;
      bottom: 0;
      min-height: 700px;
      display: none;
    }
    &:before {
      min-height: 3670px;
    }
    &__top {
      padding-top: 0px;
    }
    &__logotypes {
      margin-top: 50px;
      margin-bottom: 60px;
    }
    &__extension {
      padding-top: 70px;
      padding-bottom: 100px;
    }
    &__faq {
      margin-bottom: 100px;
    }
    &__title-long {
      max-width: 400px;
    }
    &__container {
      padding-top: 0;
    }
  }
}
@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .container:not(.container--fluid) {
    max-width: 1315px;
  }
  .v-content {
    padding-bottom: 154px !important;
  }
}
</style>
<i18n locale="en" lang="yaml">
btnQr: Register for free
qrTitle: Get your {0} to hire people for you
truck: van
payDesk: cashier
aBoard: advertising
qrText: With Huntica`s QR code feature, your print materials will automate your recruiting process!
titleHowItWorks: How it works
howItWorksText1: Select jobs and get your QR code.
howItWorksText2: Print promo materials with the QR code. You can change the selection of jobs after printing.
howItWorksText3: 'Your clients will see your hiring ad, scan the code with their smartphones and record an interview. {0}'
dialogHeader: Scan the QR code
demo: See how it works
howItWorksText4: Watch interviews on a user-friendly interface and hire the best candidates.
titleExamples: Examples of how to use it/ samples/how to use it
btnExamples: Try Huntica
titleReviews: Reviews
registration: Registration
slogan: Huntica is the first automated interview service with a real person
sloganShort: The first automated interview service with a real person
</i18n>
<i18n locale="ru" lang="yaml">
btnQr: Зарегистрироваться бесплатно
qrTitle: Пусть {0} нанимает людей
truck: твой грузовик
payDesk: твоя касса
aBoard: твой стенд
qrText: 'Генерируйте QR коды, по которым соискатель сможет узнать все про ваши вакансии и пройти собеседование с телефона'
titleHowItWorks: Как это работает
howItWorksText1: 'Создайте подборку вакансий, получите QR-код'
howItWorksText2: 'Распечатайте промо-материалы с QR-кодом. Вы можете редактировать подборку вакансий, не меняя QR-код.'
howItWorksText3: 'Клиенты видят ваше объявление о найме, сканируют QR- код со своих смартфонов и записывают интервью.  {0}'
dialogHeader: 'Отсканируйте QR код'
demo: Как это работает
howItWorksText4: 'Просматривайте собеседования в удобном интерфейсе и нанимайте лучших кандидатов.'
titleExamples: Примеры использования
btnExamples: Попробовать Huntica
titleReviews: Отзывы
registration: Регистрация
slogan: Huntica — сервис виртуальных собеседований с человеческим лицом
sloganShort: сервис виртуальных собеседований с человеческим лицом
</i18n>
